module.exports = __webpack_public_path__ + "img/education.8a144773.svg";